import React, { ReactElement, ReactNode } from 'react';
import styles from './FormatInformation.module.scss';
import { Link } from 'react-router-dom';
import { Typography } from '../Typography/Typography';

type IFormatInformationParams = {
  heading: string;
  information: ReactNode | ReactNode[];
  link?: string;
};

export const FormatInformation = ({ heading, information, link }: IFormatInformationParams): ReactElement => {
  return (
    <div role="heading" className={styles['container']}>
      <Typography className={styles['title']} size="M" weight="bold">
        {heading}
      </Typography>
      {link && information ? (
        <Link className={styles['link']} to={link}>
          {information}
        </Link>
      ) : (
        <Typography>{information || information === 0 ? information : `No ${heading}`}</Typography>
      )}
    </div>
  );
};
